import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { tokens } from '@everfi/design-system';
import { DismissAction } from './dismiss-action.js';
import { DragHandle } from './drag-handle.js';
import { CardSpecialLabel } from '../../CardComponents/card-special-label/component.js';
import { MediaBox } from './media-box.js';
import { ParentBox } from './parent-box.js';
import { TextBox } from './text-box.js';
import { CardActions } from './card-actions.js';
import { CardChildren } from './card-children.js';
import { Layout } from '../../../core/components/Layout/component.js';
var DefaultCardContainer = function DefaultCardContainer(_ref) {
  var cardProps = _ref.cardProps,
    cardEffects = _ref.cardEffects;
  var type = cardProps.type,
    isSortable = cardProps.isSortable,
    specialLabel = cardProps.specialLabel,
    dismissable = cardProps.dismissable,
    onDismiss = cardProps.onDismiss,
    mediaPosition = cardProps.mediaPosition,
    _cardProps$mediaSize = cardProps.mediaSize,
    mediaSize = _cardProps$mediaSize === void 0 ? cardProps.type === 'narrow' ? 'full' : 'large' : _cardProps$mediaSize,
    _cardProps$styleConfi = cardProps.styleConfig,
    styleConfig = _cardProps$styleConfi === void 0 ? {
      mediaBackground: 'white'
    } : _cardProps$styleConfi,
    _cardProps$buttonPosi = cardProps.buttonPosition,
    buttonPosition = _cardProps$buttonPosi === void 0 ? type === 'narrow' || type === 'mini' ? 'bottom' : 'top' : _cardProps$buttonPosi,
    children = cardProps.children,
    containerClass = cardProps.containerClass,
    noMediaBorderRadius = cardProps.noMediaBorderRadius;
  var _ref2 = styleConfig || {},
    mediaBackground = _ref2.mediaBackground;
  var hasMedia = cardEffects.hasMedia,
    showChildren = cardEffects.showChildren;
  var backgrounds = {
    white: tokens.ColorsWhite,
    gray: tokens.ColorsGrey200,
    light: tokens.ColorsTeal100
  };
  var mediaSizes = {
    icon: '192px',
    small: '192px',
    large: '272px',
    full: '100%'
  };
  var buttonPositions = {
    top: 'flex-start',
    middle: 'center',
    bottom: 'flex-end'
  };
  var flexDirection = type === 'narrow' || type === 'mini' ? 'column' : 'row';
  return /*#__PURE__*/React.createElement(Layout, {
    overflow: "hidden",
    height: showChildren ? 'auto' : '100%',
    className: containerClass
  }, dismissable && /*#__PURE__*/React.createElement(Layout, {
    position: "relative",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Layout, {
    position: "absolute",
    right: "0",
    margin: tokens.SpacingBaseXs
  }, /*#__PURE__*/React.createElement(DismissAction, {
    dismissable: dismissable,
    onDismiss: onDismiss
  }))), /*#__PURE__*/React.createElement(Layout, {
    variant: "flex",
    height: "100%",
    flexDirection: ['column', 'column', 'column', flexDirection, flexDirection, flexDirection],
    alignItems: "flex-start"
  }, /*#__PURE__*/React.createElement(Layout, {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    width: type === 'narrow' ? '100%' : '',
    background: type === 'narrow' && mediaBackground ? backgrounds[mediaBackground] : '',
    justifyContent: mediaPosition
  }, /*#__PURE__*/React.createElement(Layout, {
    alignSelf: "flex-start"
  }, /*#__PURE__*/React.createElement(DragHandle, {
    isSortable: isSortable
  })), /*#__PURE__*/React.createElement(Layout, {
    minWidth: hasMedia ? mediaSizes[mediaSize] : 'max-content',
    maxWidth: hasMedia ? mediaSizes[mediaSize] : 'none'
  }, specialLabel && /*#__PURE__*/React.createElement(CardSpecialLabel, _extends({}, specialLabel, {
    chakra: 'on',
    hasMedia: hasMedia,
    type: type
  })), hasMedia && /*#__PURE__*/React.createElement(Layout, {
    margin: mediaSize === 'full' ? 0 : tokens.SpacingBaseMd,
    borderRadius: mediaSize === 'full' || noMediaBorderRadius ? 0 : tokens.BorderRadiiMd,
    overflow: "hidden"
  }, /*#__PURE__*/React.createElement(MediaBox, {
    cardProps: cardProps,
    cardEffects: cardEffects
  }))), children && /*#__PURE__*/React.createElement(Layout, {
    display: ['none', 'none', 'none', 'flex', 'flex', 'flex'],
    margin: tokens.SpacingBaseMd
  }, /*#__PURE__*/React.createElement(ParentBox, {
    cardProps: cardProps,
    cardEffects: cardEffects
  }))), /*#__PURE__*/React.createElement(Layout, {
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement(Layout, {
    variant: "flex",
    flexDirection: ['column', 'column', 'column', flexDirection, flexDirection, flexDirection],
    height: "100%"
  }, /*#__PURE__*/React.createElement(TextBox, {
    cardProps: cardProps,
    cardEffects: cardEffects
  }), /*#__PURE__*/React.createElement(Layout, {
    variant: "flex",
    alignItems: buttonPositions[buttonPosition],
    flexDirection: type === 'narrow' || type === 'mini' ? 'column' : 'row',
    paddingTop: tokens.SpacingBaseXs
  }, /*#__PURE__*/React.createElement(CardActions, {
    cardProps: cardProps
  })))), children && /*#__PURE__*/React.createElement(Layout, {
    display: ['flex', 'flex', 'flex', 'none', 'none', 'none'],
    margin: tokens.SpacingBaseMd
  }, /*#__PURE__*/React.createElement(ParentBox, {
    cardProps: cardProps,
    cardEffects: cardEffects
  }))), /*#__PURE__*/React.createElement(CardChildren, {
    cardProps: cardProps,
    cardEffects: cardEffects
  }));
};
DefaultCardContainer.displayName = "DefaultCardContainer";
export { DefaultCardContainer };